import { post } from '~/plugins/nikan-api'
import Endpoints from '@nikan/endpoints'
import _ from 'lodash'


export const state = {
  frequentDescriptionsList: [],
  fetched: false
}

export const mutations = {
  set(state, frequentDescriptionsList) {
    state.frequentDescriptionsList = [].concat(frequentDescriptionsList)
    state.fetched = true
  },
}

export const actions = {
  async refresh({ state, commit }, options) {
    options = _.merge({ force: false }, options)
    if (options.force || !state.fetched) {
    state.fetched = true
    await post(Endpoints.getUrl('frequentDescriptions.list'), null, null, { preventCuncurrent: true })
        .then(data => {
          commit('set', data.data.items)
        })
    }
  }
}

export const getters = {
  all: state => {
    return state.frequentDescriptionsList
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
